import ErrorService from "@exceptions/ErrorHandler";
import { NoResponseDataError } from "@exceptions/NoResponseDataError";
import store from "@store/store";
import { showLoader, hideLoader } from "@redux/loaderSlice";

export async function handleApiResponse<T>(params: {
  url: string;
  apiCallFunction: (url: string, data?: any) => Promise<any>;
  convertResponseDataFunction: (data: any) => T;
  data?: any;
  isLoader?: boolean;
}): Promise<T> {
  try {
    const shouldShowLoader = params.isLoader !== false;
    if (shouldShowLoader) store.dispatch(showLoader());

    const response = await params.apiCallFunction(params?.url, params?.data);
    if (!response?.data) {
      if (shouldShowLoader) {
        store.dispatch(hideLoader());
      }
      throw new NoResponseDataError();
    }
    if (shouldShowLoader) {
      store.dispatch(hideLoader());
    }
    return params.convertResponseDataFunction(response?.data);
  } catch (error) {
    if (params.isLoader !== false) store.dispatch(hideLoader());
    ErrorService.reportError(error);
    throw error;
  }
}
